<template>
  <div>
    <input @keyup="onChange" v-model="currentValue" type="text"
      class="border border-grey rounded-lg
            md:h-12 mr-2 mt-4 p-4 text-center
            sm:h-16 sm:text-xl">
  </div>
</template>

<script>
export default {
  name: 'MoneyInput',
  props: ['initValue', 'tier'],
  data () {
    return {
      currentValue: 0
    }
  },
  mounted () {
    if (this.initValue) {
      this.currentValue = this.$options.filters.currency(this.initValue / 100)
    }
  },
  methods: {
    convertToCents (value) {
      if (value && value !== '') {
        return parseInt(value.replace(/[^\d]/g, ''))
      }

      return 0
    },
    onChange () {
      // stripe out symbols and decimals
      if (this.currentValue !== '') {
        this.currentValue = this.$options.filters.currency(this.convertToCents(this.currentValue) / 100)
      }
    },
    getValue () {
      return this.convertToCents(this.currentValue)
    },
    getTier () {
      return this.tier
    },
    isValid () {
      return this.currentValue && this.currentValue > 0
    },
    reset () {
      this.currentValue = 0
    }
  }
}
</script>
